import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';

const initialState = {
	name: '',
	nameError: false,
	nameErrorMessage: 'Name is required',
	emailError: false,
	emailErrorMessage: 'Invalid Email',
	lastName: '',
	mobile: '',
	mobileError: false,
	mobileErrorMessage: 'Invalid phone number',
	residencia: '',
	residenciaError: false,
	residenciaErrorMessage: 'City of residence is required',
	licencia: '',
	licenciaError: false,
	licenciaErrorMessage: 'Driving license type is required',
	position: '',
	positionError: false,
	positionErrorMessage: 'Position is required',
	document: null,
	documentError: false,
	documentErrorMessage: 'Document is required',
	showModal: false,
	responseMessage: '',
	status: null,
};

const TarbajaForm = ({ operator, actions }) => {
	const [state, setState] = useState(initialState);

	const onChange = (value, type) => {
		setState({
			...state,
			[type]: value,
			[`${type}Error`]: false,
		});
	};

	const validate = () => {
		let valid = true;
		let errors = {};

		if (!state.name.trim()) {
			errors.nameError = true;
			errors.nameErrorMessage = 'Name is required';
			valid = false;
		}

		if (!state.email || !/\S+@\S+\.\S+/.test(state.email)) {
			errors.emailError = true;
			errors.emailErrorMessage = 'Invalid email address';
			valid = false;
		}

		if (!state.mobile || !/^\d{9}$/.test(state.mobile)) {
			errors.mobileError = true;
			errors.mobileErrorMessage = 'Invalid phone number';
			valid = false;
		}

		if (!state.residencia.trim()) {
			errors.residenciaError = true;
			errors.residenciaErrorMessage = 'City of residence is required';
			valid = false;
		}

		if (!state.licencia.trim()) {
			errors.licenciaError = true;
			errors.licenciaErrorMessage = 'Driving license type is required';
			valid = false;
		}

		if (!state.position.trim()) {
			errors.positionError = true;
			errors.positionErrorMessage = 'Position is required';
			valid = false;
		}

		if (!state.document) {
			errors.documentError = true;
			errors.documentErrorMessage = 'Document is required';
			valid = false;
		}

		setState({
			...state,
			...errors,
		});

		return valid;
	};

	const onSubmit = () => {
		if (!validate()) {
			return;
		}

		const data = {
			name: state.name,
			telephone: state.mobile,
			email: state.email,
			operator_id: operator.operator_id,
			city_of_residence: state.residencia,
			licence_type: state.licencia,
			position_applying_for: state.position,
			// resume:state.document,
		};
		const formData = new FormData();
		Object.keys(data).forEach(key => {
			formData.append(key, data[key]);
		});
		formData.append('resume', state.document);
		// const data = {
		// 	name: state.name,
		// 	email: state.email,
		// 	phone_number: state.mobile,
		// 	residencia: state.residencia,
		// 	licencia: state.licencia,
		// 	position: state.position,
		// 	ducument: state.document,
		// 	operator_id: operator.operator_id,
		// 	operator_name: operator.operator_name,
		// };

		// const formData = new FormData();
		// Object.keys(data).forEach(key => {
		// 	formData.append(key, data[key]);
		// });
		// formData.append('document', state.document);

		actions.apiCall({
			url: `${AppData.BASE_URL}/api/work_with_us`,
			method: 'POST',
			data: formData,
		})
			.then(res => onContactInfoResponse(res))
			.catch(err => onContactInfoResponse(err.response));
	};

	const onContactInfoResponse = res => {
		setState({
			...state,
			showModal: true,
			responseMessage: res.data.message || 'Something went wrong',
			status: res.status,
		});
	};

	return (
		<div className="themes-theme-two-contact-section">
			<div className="form">
				<div className="form-inputs-new">
					<div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
						<div className="contact-input-item" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Nombre</div>
							<KuposInput
								type="text"
								value={state.name}
								onChange={value => onChange(value, 'name')}
								error={state.nameError}
								errorMessage={state.nameErrorMessage}
							/>
						</div>
						<div className="contact-input-item" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Correo electrónico</div>
							<KuposInput
								type="text"
								value={state.email}
								onChange={value => onChange(value, 'email')}
								error={state.emailError}
								errorMessage={state.emailErrorMessage}
							/>
						</div>

					</div>

					<div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
						<div className="contact-input-item" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Teléfono</div>
							<KuposInput
								type="text"
								value={state.mobile}
								onChange={value => onChange(value, 'mobile')}
								error={state.mobileError}
								errorMessage={state.mobileErrorMessage}
							/>
						</div>
						<div className="contact-input-item" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Ciudad de residencia</div>
							<KuposInput
								type="text"
								value={state.residencia}
								onChange={value => onChange(value, 'residencia')}
								error={state.residenciaError}
								errorMessage={state.residenciaErrorMessage}
							/>
						</div>
					</div>
					<div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
						<div className="contact-input-item" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Tipo de licencia de conducir</div>
							<KuposInput
								type="text"
								value={state.licencia}
								onChange={value => onChange(value, 'licencia')}
								error={state.licenciaError}
								errorMessage={state.licenciaErrorMessage}
							/>
						</div>
						<div className="contact-input-item" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Cargo al que postula:</div>
							<KuposInput
								type="text"
								value={state.position}
								onChange={value => onChange(value, 'position')}
								error={state.positionError}
								errorMessage={state.positionErrorMessage}
							/>
						</div>
					</div>
					<div className="last-form-tarabjas" style={{ display: 'flex', gap: '10px', marginBottom: '15px', alignItems: 'flexEnd', justifyContent: 'spaceBetween' }}>
						{/* <div className="contact-input-item  text-area-inputs" style={{ width: '50%' }}>
							<div className="contact-input-label bold-text">Adjuntar documento"</div>
							<input
								type="file"
								onChange={e => onChange(e.target.files[0], 'document')}
							/>
							<img src="assets/santarosa/icons/pin.svg" className='pin' />
							{state.documentError && <div className="error-message">{state.documentErrorMessage}</div>}
						</div> */}
						<div
							className={`contact-input-item text-area-inputs ${state.document ? 'file-fields' : ''}`}
							style={{ width: '50%' }}
						>
							<div className="contact-input-label bold-text">Adjuntar documento</div>
							<div className='file-input-before'>
								{state.document ? (
									// Display the file name instead of the input when a file is selected
									<div className="file-name-display">
										<img src="assets/santarosa/icons/pin.svg" className="pin" />
										<span>{state.document.name}</span>
									</div>
								) : (
									// Render the input if no file is selected
									<div >
										<input
											type="file"
											onChange={(e) => onChange(e.target.files[0], 'document')}
											accept=".pdf,.doc,.docx"
										/>
									</div>
								)}
								<img src="assets/santarosa/icons/pin.svg" className="pin" />
								{state.documentError && <div className="error-message">{state.documentErrorMessage}</div>}
							</div>
						</div>


						<KuposButton onClick={onSubmit} className="kupos-button button-padding santabutton">Enviar</KuposButton>

					</div>
				</div>

			</div>
			<KuposErrorSuccessModal
				success={state.status === 200}
				showModal={state.showModal}
				onButtonClick={() => setState({ ...initialState })}
				bodyText={state.responseMessage}
			/>
		</div >
	);
};

export default TarbajaForm;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/TarbajaForm.js